module.exports = __webpack_public_path__ + "img/no_data.222e96ba.png";